import React from "react";

const PlaylistScreen = () => {
  return (
    <div className="Podcast">
      <ul>
        <li>Create Playlist!</li>
      </ul>
    </div>
  );
};

export default PlaylistScreen;
